// extracted by mini-css-extract-plugin
export default {"header":"styles_header__19EN7","title":"styles_title__MKQbX","graphDescription":"styles_graphDescription__cRB3h"};